// extracted by mini-css-extract-plugin
module.exports = {"container":"Text_container__1QtBn","toolbar":"Text_toolbar__2Ik6h","toolbarButton":"Text_toolbarButton__2Qzrt","editor":"Text_editor__2SDgc","flex1":"Text_flex1__192fw"};